export enum ReferralServiceType {
  Broker = 200,
  Agent = 300,
  Client = 400,
}
